function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from "../styles";
// import { useStyles }

const Root = styled("div")(() => ({
  flex: "1 0 auto",
  display: "flex"
}));
const LoadingContainer = styled("div")(() => ({
  margin: "0px auto",
  alignSelf: "center"
}));
const FlexLoading = _ref => {
  let {
    size = 'small',
    ...props
  } = _ref;
  // TODO: this should be overridable by the theme
  const sizeValues = {
    small: 24,
    medium: 48,
    large: 96
  };

  // TODO: this should be overridable
  const thicknessValues = {
    small: 3.6,
    medium: 2,
    large: 1.3
  };
  const sizeNumber = sizeValues[size];
  const thicknessNumber = thicknessValues[size];
  return /*#__PURE__*/React.createElement(Root, null, /*#__PURE__*/React.createElement(LoadingContainer, null, /*#__PURE__*/React.createElement(CircularProgress, _extends({
    size: sizeNumber,
    thickness: thicknessNumber
  }, props))));
};
export default FlexLoading;